// Central origin/base-path logic, shared by api.ts and tenant.ts (kept in its own
// module so neither imports the other — avoids an import cycle).

// The SPA is served under /zta; BASE_PATH is that prefix without a trailing slash.
export const BASE_PATH = import.meta.env.BASE_URL.replace(/\/$/, '');

// Local dev = localhost, any *.localhost subdomain (e.g. jabez.localhost), or 127.0.0.1.
export const isLocal = (): boolean => {
  const h = window?.location?.hostname || '';
  return h === 'localhost' || h.endsWith('.localhost') || h === '127.0.0.1';
};

// In local dev the frontend goes through the Vite dev-server proxy by default, which
// forwards /zta/api and /zta/agent to VITE_API_PROXY_TARGET (vite.config.ts). Set
// VITE_API_URL only to call a local backend DIRECTLY, bypassing the proxy (the backend
// must then allow CORS). A local backend serves /api/v1 with NO /zta prefix, so that
// direct origin must not include BASE_PATH.
const DIRECT_API_URL = ((import.meta.env.VITE_API_URL as string) || '').replace(/\/$/, '');
export const LOCAL_API_URL = DIRECT_API_URL || 'http://localhost:8080';

const callsDirect = (): boolean => isLocal() && DIRECT_API_URL !== '';

// apiOrigin is the prefix for same-origin API request paths: the direct backend origin
// when VITE_API_URL is set in local dev, else the /zta base path (which Vite/nginx
// proxies to the backend).
export const apiOrigin = (): string => (callsDirect() ? DIRECT_API_URL : BASE_PATH);

// wsOrigin mirrors apiOrigin for WebSocket URLs.
export const wsOrigin = (): string => {
  if (callsDirect()) return DIRECT_API_URL.replace(/^http/, 'ws');
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}${BASE_PATH}`;
};
